import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useAxios } from '../../hooks/useAxios';
import axios from 'axios';
import Alert from 'react-bootstrap/Alert';
import { Console, MLInstance } from '../../services/platform-api';
import { GetUserEmail } from '../../services/get-user-email';
import { useSessionStorage } from '../../hooks/useSessionStorage';
import { WorkflowConfig } from '../workflow-config';
import { Preloader } from '../preloader';
import CSVUploader from '../csv-uploader';
import HeaderSelector from '../header-selector';
import StatusMessages from '../recipe-status-messages';

import PongGame from '../../components/pongGame';
import '../../assets/css/pong.scss';

const ReconciliationWorkFlow = ({
  workato_recipe_id,
  combination_id,
  connectors,
  activeTab,
  arc_tab_ref1,
  arc_tab_ref2,
  webhook_url,
  recipeSetupStatus,
  recipeActive,
  refreshTheRecipe,
}) => {
  const [workato_id] = useSessionStorage('workatoId', '');
  const [WJST_id] = useSessionStorage('WJST_id', 1);
  const email = GetUserEmail();
  const [userId] = useSessionStorage('userId', '');

  // - start report jobs
  const {
    data: defaultReportJobID = null,
    fetchNow: starJobDefaultReport,
    resetData: resetDefaultReportJobID,
  } = useAxios();
  const {
    data: customReportJobID = null,
    fetchNow: starJobCustomReport,
    resetData: resetCustomReportJobID,
  } = useAxios();
  // result from report complete poll
  const {
    data: defaultReportJobResult = null,
    fetchNow: checkDefaultReportJob,
    resetData: resetDefaultReportJob,
  } = useAxios();
  const {
    data: customReportJobResult = null,
    fetchNow: checkCustomReportJob,
    resetData: resetCustomReportJob,
  } = useAxios();

  // - start email jobs
  const {
    data: defaultEmailJobID = null,
    fetchNow: starJobDefaultEmail,
    resetData: resetDefaultEmailJobID,
  } = useAxios();
  const { data: customEmailJobID = null, fetchNow: starJobCustomEmail, resetData: resetCustomEmailJobID } = useAxios();

  // result from email complete poll
  const {
    data: defaultEmailJobResult = null,
    fetchNow: checkDefaultEmailtJob,
    resetData: resetDefaultEmailJob,
  } = useAxios();
  const {
    data: customEmailJobResult = null,
    fetchNow: checkCustomEmailJob,
    resetData: resetCustomEmailJob,
  } = useAxios();

  const { data: lookupTableData = null, fetchNow: checkWorkatoJobStatus } = useAxios();

  const [startEmailDefault, setStartEmailDefault] = useState(false);
  const [startEmailCustom, setStartEmailCustom] = useState(false);
  const [headers, setHeaders] = useState(null);
  const [selectedHeader, setSelectedHeader] = useState('');
  const [headers2, setHeaders2] = useState(null);
  const [selectedHeader2, setSelectedHeader2] = useState('');

  const [selectedTone1, setSelectedTone1] = useState('');
  const [selectedTone2, setSelectedTone2] = useState('');
  const [emailNotMatchedisChecked, setEmailNOTMatchedisChecked] = useState(false);
  const [emailMatchedisChecked, setEmailMatchedisChecked] = useState(false);
  const [generateInternalMemo, setGenerateInternalMemo] = useState(false);

  const [defaultComparison, setDefaultComparison] = useState(null);
  const [customComparison, setCustomComparison] = useState(null);
  const [defaultMeta, setDefaultMeta] = useState(null);
  const [testMeta, setCustomMeta] = useState(null);
  const [defaultDiscrepancies, setDefaultDiscrepancies] = useState(null);
  const [defaultUnmatched, setDefaultUnmatched] = useState(null);
  const [customDiscrepancies, setCustomDiscrepancies] = useState(null);
  const [customUnmatched, setCustomUnmatched] = useState(null);

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState('');
  const [selectedFile2, setSelectedFile2] = useState(null);
  const [selectedFileName2, setSelectedFileName2] = useState('');

  const [jobIntervals, setJobIntervals] = useState({});
  const [jobStatusIntervalId, setJobStatusIntervalId] = useState();

  const [settingUpRecipe, setSettingUpRecipe] = useState(true);
  const [runWorkflow, setRunWorkflow] = useState(false);

  const handleClose = () => setShowModal(false);
  const [showModal, setShowModal] = useState(false);
  const handleClosePong = () => setShowModalPong(false);
  const [showPong, setShowModalPong] = useState(false);
  const handleClosePongOffer = () => setShowPongOffer(false);
  const [showPongOffer, setShowPongOffer] = useState(false);
  const [showBtnReady, setShowBtnReady] = useState(false);
  const today = new Date();
  const date = today.toLocaleDateString();
  const time = today.toLocaleTimeString();
  const [resetStatuses, setResetStatuses] = useState(false);

  const {
    get_config,
    wf_config,
    setWFConfig,
    save_wf_config,
    fetchSetting,
    setFetchSetting,
    configAlertType,
    configAlertContent,
    configChanged,
    setConfigChanged,
    wf_configSet,
  } = WorkflowConfig({
    combination_id: combination_id,
  });

  const workato_headers = {
    'Content-type': 'application/json',
    'x-user-email': 'integrations@arcanum.ai',
    'x-user-token': '62f4f964-1743-4667-88a3-6b2d2506a159',
  };

  // PONG GAMWE AND RESULT CONTROL
  useEffect(() => {
    if (defaultComparison && customComparison) {
      setShowPongOffer(false);
      if (showPong) {
        setShowBtnReady(true);
      } else {
        setShowPongOffer(false);
        setShowModal(true);
      }
    }
  }, [customComparison, defaultComparison]);

  useEffect(() => {
    setSettingUpRecipe(recipeSetupStatus === 'complete' ? false : true);
  }, [recipeSetupStatus]);

  // On file upload (click the upload button)
  const onFileUpload = () => {
    arc_tab_ref1.current.click();
  };

  useEffect(() => {
    // if we are ready to run the workflow and we also have config set then lets run it
    if (runWorkflow && wf_configSet && wf_config !== null && !configChanged) {
      run_workflow();
    }
    if (configChanged) {
      save_this_config();
    }

    // report job id
    if (defaultReportJobID && defaultReportJobResult === null) {
      if (defaultReportJobID.status !== 'error') {
        run_job_check(defaultReportJobID.jobId?.wf_id, 'default', 'report');
      } else {
        Console('error found: ', defaultReportJobID);
        setDefaultComparison(defaultReportJobID); // error
      }
    }
    if (customReportJobID && customReportJobResult === null) {
      if (customReportJobID.status !== 'error') {
        run_job_check(customReportJobID.jobId?.wf_id, 'custom', 'report');
      } else {
        setCustomComparison(customReportJobID); // error output
      }
    }
    // email job id
    if (defaultEmailJobID && defaultEmailJobResult === null) {
      if (defaultEmailJobID.status !== 'error') {
        run_job_check(defaultEmailJobID.jobId?.email_id, 'default', 'email');
      } else {
        setDefaultComparison(defaultEmailJobID?.message); // error
      }
    }
    if (customEmailJobID && customEmailJobResult === null) {
      if (customEmailJobID.status !== 'error') {
        run_job_check(customEmailJobID.jobId?.email_id, 'custom', 'email');
      } else {
        setCustomComparison(customEmailJobID?.message); // error
      }
    }

    // Results from polling job status
    //
    // Reports
    //
    // DEFAULT
    if (
      defaultReportJobResult &&
      (defaultReportJobResult.status === 'COMPLETE' || defaultReportJobResult.status === 'FAILED')
    ) {
      clearInterval(jobIntervals['defaultreport']);
      if (defaultReportJobResult && defaultReportJobResult.status === 'COMPLETE') {
        setDefaultMeta(defaultReportJobResult?.metadata);
        setDefaultDiscrepancies(defaultReportJobResult?.data?.raw?.matched_records);
        setDefaultUnmatched(defaultReportJobResult?.data?.raw?.unmatched_records);

        if (defaultReportJobResult?.data && !startEmailDefault) {
          const payload = {
            default: false,
            combination_id: combination_id,
            report: defaultReportJobResult.data.uri,
          };
          starJobDefaultEmail(`/api/platform/invoice_reconciliation/start_email`, 'POST', payload, false);
          setStartEmailDefault(true);
        }
      } else {
        // TODO
        setDefaultComparison('Test Failed, check your file default report');
      }
    }

    // CUSTOM
    if (
      customReportJobResult &&
      (customReportJobResult.status === 'COMPLETE' || customReportJobResult.status === 'FAILED')
    ) {
      clearInterval(jobIntervals['customreport']);
      if (customReportJobResult && customReportJobResult.status === 'COMPLETE') {
        setCustomMeta(customReportJobResult?.metadata);
        setCustomDiscrepancies(defaultReportJobResult?.data?.raw?.matched_records);
        setCustomUnmatched(defaultReportJobResult?.data?.raw?.unmatched_records);
        if (customReportJobResult?.data && !startEmailCustom) {
          const payload = {
            default: true,
            combination_id: combination_id,
            report: customReportJobResult.data.uri,
          };
          starJobCustomEmail(`/api/platform/invoice_reconciliation/start_email`, 'POST', payload, false);
          setStartEmailCustom(true);
        }
      } else {
        setCustomComparison('Test Failed, check your file');
      }
    }

    // Email Response
    //
    // DEFAULT
    if (
      defaultEmailJobResult &&
      (defaultEmailJobResult.status === 'COMPLETE' || defaultEmailJobResult.status === 'FAILED')
    ) {
      clearInterval(jobIntervals['defaultemail']);
      if (defaultEmailJobResult && defaultEmailJobResult.status === 'COMPLETE') {
        setDefaultComparison(defaultEmailJobResult?.data?.raw);
      } else {
        // TODO
        setDefaultComparison('Test Failed, check your file - default email');
      }
    }

    // CUSTOM
    if (
      customEmailJobResult &&
      (customEmailJobResult.status === 'COMPLETE' || customEmailJobResult.status === 'FAILED')
    ) {
      clearInterval(jobIntervals['customemail']);
      if (customEmailJobResult && customEmailJobResult.status === 'COMPLETE') {
        // TO DO - output the results to the modal
        setCustomComparison(customEmailJobResult?.data?.raw);
      } else {
        setCustomComparison('Test Failed, check your file');
      }
    }

    if (wf_config && fetchSetting === 'get_config') {
      setSelectedHeader(wf_config.variables.INVOICE_PRIMARY_KEY);
      setSelectedHeader2(wf_config.variables.PURCHASE_ORDER_PRIMARY_KEY);
      setSelectedTone1(wf_config.variables.EMAIL_TONE_OF_VOICE_MATCHED);
      setSelectedTone2(wf_config.variables.EMAIL_TONE_OF_VOICE_NOT_MATCHED);
      setEmailNOTMatchedisChecked(wf_config.variables.GENERATE_EMAIL_FOR_NOT_MATCHED);
      setEmailMatchedisChecked(wf_config.variables.GENERATE_EMAIL_FOR_MATCHED);
      setGenerateInternalMemo(wf_config.variables.GENERATE_INTERNAL_MEMO_FOR_NOT_MATCHED);
      setFetchSetting('');
    }
  }, [
    runWorkflow,
    wf_configSet,
    wf_config,
    defaultReportJobID,
    customReportJobID,
    customEmailJobID,
    defaultEmailJobID,
    fetchSetting,
    configChanged,
    defaultReportJobResult,
    customReportJobResult,
    defaultEmailJobResult,
    customEmailJobResult,
    startEmailDefault,
    startEmailCustom,
  ]);

  const run_job_check = (the_job_id, whichJob, job_type) => {
    // Check if an interval for the given job already exists
    if (jobIntervals[whichJob + job_type]) {
      return;
    }

    const intervalId = setInterval(() => {
      // check job loop
      let payload;
      if (job_type === 'report') {
        payload = {
          jobId: {
            wf_id: the_job_id,
          },
        };
      } else if (job_type === 'email') {
        payload = {
          jobId: {
            email_id: the_job_id,
          },
        };
      }

      let url = `${MLInstance}/api/reconciliation/complete/`;
      if (whichJob === 'default') {
        if (job_type === 'report') {
          checkDefaultReportJob(url, 'POST', payload);
        } else {
          checkDefaultEmailtJob(url, 'POST', payload);
        }
      } else if (whichJob === 'custom') {
        if (job_type === 'report') {
          checkCustomReportJob(url, 'POST', payload);
        } else {
          checkCustomEmailJob(url, 'POST', payload);
        }
      }
    }, 5000);

    // Update the jobIntervals state with the new intervalId
    setJobIntervals((jobIntervals) => ({
      ...jobIntervals,
      [whichJob + job_type]: intervalId,
    }));
  };

  const stopJobStatusPoll = () => {
    clearInterval(jobStatusIntervalId);
  };

  // runs the workato webhook recipe for this flow
  const run_workflow = () => {
    setResetStatuses(true);

    let file_to_upload = '';
    file_to_upload = selectedFile.replace('data:image/png;base64,', '');
    file_to_upload = file_to_upload.replace('data:application/pdf;base64,', '');
    file_to_upload = file_to_upload.replace('data:text/csv;base64,', '');

    let file_to_upload2 = '';
    file_to_upload2 = selectedFile2.replace('data:image/png;base64,', '');
    file_to_upload2 = file_to_upload2.replace('data:application/pdf;base64,', '');
    file_to_upload2 = file_to_upload2.replace('data:text/csv;base64,', '');

    const payload = {
      GENERATE_INTERNAL_MEMO_FOR_NOT_MATCHED: generateInternalMemo,
      GENERATE_EMAIL_FOR_NOT_MATCHED: emailNotMatchedisChecked,
      GENERATE_EMAIL_FOR_MATCHED: emailMatchedisChecked,
      combination_id,
      email: email,
      user_id: userId,
      file_name1: selectedFileName,
      file_binary1: file_to_upload,
      file_name2: selectedFileName2,
      file_binary2: file_to_upload2,
    };
    axios({
      method: 'post',
      url: webhook_url,
      data: payload,
    })
      .then((response) => {
        if (response.status === 200) {
          // force tab change
          arc_tab_ref2.current.click();

          // run the lookup job status function
          if (WJST_id) {
            let this_id = setInterval(() => {
              // check job loop
              checkWorkatoJobStatus(
                `/api/platform/proxy?url=api/managed_users/${workato_id}/lookup_tables/${WJST_id}/rows`,
                'GET',
                null,
                workato_headers,
              );
              setResetStatuses(false);
            }, 5000);

            setJobStatusIntervalId(this_id);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
    setRunWorkflow(false);
  };

  const test_configuration = () => {
    // reset the data
    resetDefaultReportJob();
    resetCustomReportJob();
    resetDefaultEmailJob();
    resetCustomEmailJob();
    resetDefaultReportJobID();
    resetCustomReportJobID();
    resetDefaultEmailJobID();
    resetCustomEmailJobID();
    setDefaultComparison(null);
    setCustomComparison(null);
    setJobIntervals([]);
    setDefaultMeta(null);
    setDefaultDiscrepancies(null);
    setDefaultUnmatched(null);
    setCustomDiscrepancies(null);
    setCustomUnmatched(null);
    setCustomMeta(null);
    setStartEmailDefault(false);
    setStartEmailCustom(false);

    setShowBtnReady(false);

    if (wf_configSet) {
      setShowPongOffer(true);

      let file_to_upload = '';
      file_to_upload = selectedFile.replace('data:image/png;base64,', '');
      file_to_upload = file_to_upload.replace('data:application/pdf;base64,', '');
      file_to_upload = file_to_upload.replace('data:text/csv;base64,', '');

      let file_to_upload2 = '';
      file_to_upload2 = selectedFile2.replace('data:image/png;base64,', '');
      file_to_upload2 = file_to_upload2.replace('data:application/pdf;base64,', '');
      file_to_upload2 = file_to_upload2.replace('data:text/csv;base64,', '');

      const payload = {
        default: false,
        combination_id: combination_id,
        file_name1: selectedFileName,
        file_binary1: file_to_upload,
        file_name2: selectedFileName2,
        file_binary2: file_to_upload2,
      };
      starJobCustomReport(`/api/platform/invoice_reconciliation/start_report`, 'POST', payload, false);

      // run the default config version
      const payload2 = {
        default: true,
        combination_id: combination_id,
        file_name1: selectedFileName,
        file_binary1: file_to_upload,
        file_name2: selectedFileName2,
        file_binary2: file_to_upload2,
      };
      starJobDefaultReport(`/api/platform/invoice_reconciliation/start_report`, 'POST', payload2, false);
      // run the user config version
    }
  };

  // first we check if we have the config set before we run the workflow recipe
  const run_workflow_check = () => {
    setRunWorkflow(true);
    if (!wf_configSet) {
      get_config();
    }
  };

  const handleHeaderSelect = (selectedHeader) => {
    setSelectedHeader(selectedHeader);
    setConfigChanged(true);
  };
  const handleHeaderSelect2 = (selectedHeader) => {
    setSelectedHeader2(selectedHeader);
    setConfigChanged(true);
  };

  const handleCSVUpload = ({ headerFields, file, filename }) => {
    setSelectedFile(file);
    setSelectedFileName(filename);
    setHeaders(headerFields);
    //  setSelectedHeader(null);
  };
  const handleCSVUpload2 = ({ headerFields, file, filename }) => {
    setSelectedFile2(file);
    setSelectedFileName2(filename);
    setHeaders2(headerFields);
    //   setSelectedHeader2(null);
  };

  // reconciliation
  const handleEmailNotMatchedChnaged = (event) => {
    setEmailNOTMatchedisChecked(event.target.checked);
    setConfigChanged(true);
  };
  const handleEmailMatchedChnaged = (event) => {
    setEmailMatchedisChecked(event.target.checked);
    setConfigChanged(true);
  };
  const handleGenerateInternalChanged = (event) => {
    setGenerateInternalMemo(event.target.checked);
    setConfigChanged(true);
  };

  const handleToneChange1 = (event) => {
    setSelectedTone1(event.target.value);
    setConfigChanged(true);
  };
  const handleToneChange2 = (event) => {
    setSelectedTone2(event.target.value);
    setConfigChanged(true);
  };
  const save_this_config = () => {
    const payload = {
      variables: {},
    };
    // invoive reconciliation GPT
    if (selectedHeader) {
      payload.variables.INVOICE_PRIMARY_KEY = selectedHeader;
    }
    if (selectedHeader2) {
      payload.variables.PURCHASE_ORDER_PRIMARY_KEY = selectedHeader2;
    }
    if (selectedTone1) {
      payload.variables.EMAIL_TONE_OF_VOICE_MATCHED = selectedTone1;
    }
    if (selectedTone2) {
      payload.variables.EMAIL_TONE_OF_VOICE_NOT_MATCHED = selectedTone2;
    }
    if (generateInternalMemo) {
      payload.variables.GENERATE_INTERNAL_MEMO_FOR_NOT_MATCHED = generateInternalMemo;
    }
    if (emailNotMatchedisChecked) {
      payload.variables.GENERATE_EMAIL_FOR_NOT_MATCHED = emailNotMatchedisChecked;
    }
    if (emailMatchedisChecked) {
      payload.variables.GENERATE_EMAIL_FOR_MATCHED = emailMatchedisChecked;
    }
    save_wf_config(payload);
    setWFConfig(payload);
  };

  const toneOptions = [
    { value: '', label: '--Select Tone--' },
    { value: 'formal', label: 'Formal' },
    { value: 'empathetic', label: 'Empathetic' },
    { value: 'friendly', label: 'Friendly' },
    { value: 'casual', label: 'Casual' },
    { value: 'authoritative', label: 'Authoritative' },
    { value: 'humorous', label: 'Humorous' },
  ];

  const Formatandrender = ({ itemtorender }) => (
    <>
      {Object.entries(itemtorender).map(([id, message]) => (
        <div key={id}>
          <strong>{id}</strong>
          <p dangerouslySetInnerHTML={{ __html: message.replace('\n', '<br>') }} />
        </div>
      ))}
    </>
  );

  const formatFromCamel = (string) => {
    const formattedString = string
      .replace(/([a-z])([A-Z])/g, '$1 $2') // split on camel case
      .split(' ') // split on space
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize first letter
      .join(' '); // join words back together with space
    return formattedString;
  };

  const hidePongShowResult = () => {
    setShowModal(true);
    setShowModalPong(false);
  };

  const handlePlayPong = () => {
    setShowModalPong(true);
  };

  return (
    <>
      {showPongOffer && (
        <Modal
          show={showPongOffer}
          onHide={handleClosePongOffer}
          backdrop="static"
          size="lg"
          height="700px"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          dialogClassName="custom-modal"
        >
          <Row className="align-items-center d-flex flex-column justify-content-center">
            <Col className="p-5 mh_100 overflow-scroll text-center">
              <h4>
                It can take a few seconds to process your request. Want to have a quick game of pong while you wait?
              </h4>
              <br />
              <Button variant="primary" type="submit" onClick={handlePlayPong} className="px-4">
                Play Pong Game
              </Button>
              <br />
              <br />
              Or you can wait.
              <br />
              <Preloader smallscreen={true} />
              <br />
              <strong>Once the results are ready we will let alert you.</strong>
            </Col>
          </Row>
        </Modal>
      )}

      {showPong && (
        <Modal
          show={showPong}
          onHide={handleClosePong}
          backdrop="static"
          size="lg"
          height="700px"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          dialogClassName="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ width: '100%', lineHeight: '47px' }}>
              {showBtnReady ? (
                <div>
                  Processing Complete &nbsp;
                  <div class="right">
                    <Button variant="primary" type="submit" onClick={hidePongShowResult} className=" px-4">
                      See Results
                    </Button>
                  </div>
                </div>
              ) : (
                <>
                  <div class="right">
                    Processing <div className="pulse_loader">.</div>
                  </div>
                  Enjoy some PONG while you wait!
                </>
              )}
            </Modal.Title>
          </Modal.Header>
          <PongGame />
        </Modal>
      )}

      <Modal
        show={showModal}
        onHide={handleClose}
        backdrop="static"
        size="lg"
        height="700px"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            New configuration results for {selectedFileName} and {selectedFileName2} on {date} {time}
          </Modal.Title>
        </Modal.Header>
        <Row>
          <Col className="p-5 mh_100 overflow-scroll">
            <h3>Default configuration</h3>
            <br />
            {defaultMeta && (
              <>
                <table style={{ width: '100%' }}>
                  <tbody>
                    {Object.entries(defaultMeta)
                      .sort(([keyA], [keyB]) => keyA.localeCompare(keyB)) // Sort entries alphabetically by key
                      .map(([key, value]) => (
                        <tr key={key}>
                          <td style={{ width: '50%' }}>{formatFromCamel(key)}</td>
                          <td style={{ width: '50%' }}>{value}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <br />
              </>
            )}

            {defaultDiscrepancies && (
              <>
                <h5>Discrepancies:</h5>
                <Formatandrender itemtorender={defaultDiscrepancies} />
                <hr />
              </>
            )}

            {defaultUnmatched && (
              <>
                <h5>Unmatched Records:</h5>
                <Formatandrender itemtorender={defaultUnmatched} />
                <hr />
              </>
            )}

            {defaultComparison ? (
              <>
                {defaultComparison?.matched_records && (
                  <>
                    <h5>Emails - Discrepancies:</h5>
                    <Formatandrender itemtorender={defaultComparison?.matched_records} />
                    <hr />
                  </>
                )}

                {defaultComparison?.unmatched_records && (
                  <>
                    <h5>Emails - Unmatched:</h5>
                    <Formatandrender itemtorender={defaultComparison?.unmatched_records} />
                  </>
                )}

                {defaultComparison?.message && <>{defaultComparison?.message}</>}
              </>
            ) : (
              <Preloader smallscreen={true} />
            )}
          </Col>
          <Col className="p-5 mh_100 overflow-scroll">
            <h3>Your current configuration</h3>
            <br />

            {testMeta && (
              <>
                <table style={{ width: '100%' }}>
                  <tbody>
                    {Object.entries(testMeta)
                      .sort(([keyA], [keyB]) => keyA.localeCompare(keyB)) // Sort entries alphabetically by key
                      .map(([key, value]) => (
                        <tr key={key}>
                          <td style={{ width: '50%' }}>{formatFromCamel(key)}</td>
                          <td style={{ width: '50%' }}>{value}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <br />
              </>
            )}

            {customDiscrepancies && generateInternalMemo && (
              <>
                <h5>Discrepancies:</h5>
                <Formatandrender itemtorender={customDiscrepancies} />
                <hr />
              </>
            )}

            {customUnmatched && generateInternalMemo && (
              <>
                <h5>Unmatched Records:</h5>
                <Formatandrender itemtorender={customUnmatched} />
                <hr />
              </>
            )}

            {customComparison ? (
              <>
                {customComparison?.matched_records && emailMatchedisChecked && (
                  <>
                    <h5>Emails - Discrepancies:</h5>
                    <Formatandrender itemtorender={customComparison?.matched_records} />
                    <hr />
                  </>
                )}
                {customComparison?.unmatched_records && emailNotMatchedisChecked && (
                  <>
                    <h5>Emails - Unmatched:</h5>
                    <Formatandrender itemtorender={customComparison?.unmatched_records} />
                  </>
                )}

                {customComparison?.message && <>{customComparison?.message}</>}
              </>
            ) : (
              <Preloader smallscreen={true} />
            )}
          </Col>
        </Row>
        <Modal.Footer>
          <Button onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>

      {connectors.map((connector, key) => {
        return activeTab === 'wf-conn-' + key ? (
          <Col className="basic-form" key={'conn-info' + connector?.id}>
            <>
              {settingUpRecipe ? (
                <>
                  <Preloader smallscreen={true} />
                  <br />
                  <h4 className="text-center">Getting your workflow ready</h4>
                </>
              ) : !recipeActive ? (
                <>
                  <br />
                  <h4 className="text-center">Workflow Stopped</h4>
                  <br />
                  <p className="text-center">Please start your workflow to begin.</p>
                </>
              ) : (
                <>
                  <header>
                    <img
                      src={`/images/${connector?.icon}`}
                      className="icon-solutions float-left"
                      alt={connector?.name}
                    />
                  </header>

                  {connector?.provider === 'manual_upload' ? (
                    <>
                      <h3>Upload your invoice & Purchase Order files</h3>

                      <div>
                        <CSVUploader
                          combination_id={combination_id}
                          selectedFile={selectedFile}
                          selectedFile2={selectedFile2}
                          onFileUpload={onFileUpload}
                          onUpload1={handleCSVUpload}
                          onUpload2={handleCSVUpload2}
                        />

                        <hr />
                      </div>
                    </>
                  ) : connector?.provider === 'xero' && connector?.name.toLowerCase().includes('input') ? (
                    <>
                      {' '}
                      <h3>Xero Input</h3>
                      <p>TO DO</p>
                    </>
                  ) : connector?.provider === 'arcanum_ai' ? (
                    <>
                      <h5>Configuration options for this flow.</h5>
                      Which fields from each file do you want to match?
                      <Row>
                        <Col lg={6}>
                          {headers && (
                            <>
                              <strong>Choose your Invoice field:</strong>
                              <br />
                              <HeaderSelector
                                uniquekey={`header-1`}
                                headers={headers}
                                onSelect={handleHeaderSelect}
                                selectedFromConfig={selectedHeader}
                              />
                            </>
                          )}
                          <br />
                        </Col>

                        <Col lg={6}>
                          {headers2 && (
                            <>
                              <strong>Choose your Purchase Order field:</strong>
                              <br />
                              <HeaderSelector
                                uniquekey={`header-2`}
                                headers={headers2}
                                onSelect={handleHeaderSelect2}
                                selectedFromConfig={selectedHeader2}
                              />
                            </>
                          )}
                          <br />
                        </Col>
                      </Row>
                      Tone of voice of emails to suppliers where we matched invoice to PO but request updates on other
                      discrepancies
                      <br />
                      <select
                        id="toneOfVoice"
                        defaultValue={selectedTone1}
                        onChange={handleToneChange1}
                        className="form-select mb-3"
                      >
                        {toneOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      <label className="custom-tick">
                        <input type="checkbox" checked={emailMatchedisChecked} onChange={handleEmailMatchedChnaged} />
                        <span className="checkmark purple-checkmark"></span>
                        Generate email for matched
                      </label>
                      <br />
                      Tone of voice of emails to suppliers where no PO match was found for the invoice.
                      <br />
                      <select
                        id="toneOfVoice"
                        defaultValue={selectedTone2}
                        onChange={handleToneChange2}
                        className="form-select mb-3"
                      >
                        {toneOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      <label className="custom-tick">
                        <input
                          type="checkbox"
                          checked={emailNotMatchedisChecked}
                          onChange={handleEmailNotMatchedChnaged}
                        />
                        <span className="checkmark purple-checkmark"></span>
                        Generate email for not matched
                      </label>
                      <label className="custom-tick">
                        <input
                          type="checkbox"
                          checked={generateInternalMemo}
                          onChange={handleGenerateInternalChanged}
                        />
                        <span className="checkmark purple-checkmark"></span>
                        Generate internal memo for not matched
                      </label>
                      <br />
                      <br />
                      <Button
                        variant="primary"
                        type="submit"
                        onClick={test_configuration}
                        className="mt-3 px-4"
                        disabled={!wf_configSet || !selectedFile || !selectedFile2 || configChanged}
                      >
                        Test Configuration
                      </Button>{' '}
                      &nbsp;
                      {combination_id !== 14 && (
                        <Button
                          variant="primary"
                          type="submit"
                          onClick={run_workflow_check}
                          className="mt-3 px-4"
                          disabled={!selectedFile || !selectedFile2 || !wf_configSet || configChanged}
                        >
                          Run Workflow
                        </Button>
                      )}
                      <Alert className="mt-3" key={configAlertType} variant={configAlertType}>
                        {configAlertContent}
                      </Alert>
                    </>
                  ) : connector?.provider === 'outlook' && connector?.name.toLowerCase().includes('output') ? (
                    <>
                      <h3>Email Output</h3>
                      <p>
                        Once the Arcanum process has completed we will send the result to connected mail account's draft
                        folder.
                      </p>
                      <StatusMessages
                        resetStatuses={resetStatuses}
                        lookupTableData={lookupTableData}
                        stopJobStatusPoll={stopJobStatusPoll}
                        WJST_id={WJST_id}
                        workato_recipe_id={workato_recipe_id}
                        refreshTheRecipe={refreshTheRecipe}
                      />
                    </>
                  ) : connector?.provider === 'manual_email' ? (
                    <>
                      <h3>Email Output</h3>
                      <p>Once the Arcanum process has completed we will send the result to your email inbox.</p>
                      <StatusMessages
                        resetStatuses={resetStatuses}
                        lookupTableData={lookupTableData}
                        stopJobStatusPoll={stopJobStatusPoll}
                        WJST_id={WJST_id}
                        workato_recipe_id={workato_recipe_id}
                        refreshTheRecipe={refreshTheRecipe}
                      />
                    </>
                  ) : null}
                </>
              )}
            </>
          </Col>
        ) : null;
      })}
    </>
  );
};

export { ReconciliationWorkFlow };
